import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaProfessor = (): TabelaColuna => ({
  Chave: 'professorTCC',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Professor</div>
})
